import GoldOne from '../../assets/Partners/Gold/Gowri-Shankar.webp'
import GoldTwo from '../../assets/Partners/Gold/Juno.webp'
import SilverOne from '../../assets/Partners/garrett-full.png'
import SilverTwo from '../../assets/Partners/Silver/Igus.webp'
import SilverThree from '../../assets/Partners/Silver/Searock.webp'
import BronzeOne from '../../assets/Partners/Bronze/adler-fire-logo.webp'
import BronzeTwo from '../../assets/Partners/Bronze/AnilLogo.webp'
import BronzeThree from '../../assets/Partners/Bronze/banna-spray-paints.webp'
import BronzeFour from '../../assets/Partners/Bronze/bharat-rubber.webp'
import BronzeFive from '../../assets/Partners/Bronze/Display-mart.webp'
import BronzeSix from '../../assets/Partners/Bronze/eastern-rubber.webp'
import BronzeSeven from '../../assets/Partners/Bronze/hanu-heat-treaters.webp'
import BronzeEight from '../../assets/Partners/Bronze/knorr-brense-parekh-agencies.webp'
import BronzeNine from '../../assets/Partners/Bronze/manjunath-metal-finishers.webp'
import BronzeTen from '../../assets/Partners/Bronze/mipox-abrasives.webp'
import BronzeEleven from '../../assets/Partners/Bronze/Safemart_bad.webp'
import BronzeTwelve from '../../assets/Partners/Bronze/Smaaash.webp'
import BronzeThirteen from '../../assets/Partners/Bronze/smartlink.webp'
import BronzeFourteen from '../../assets/Partners/Bronze/tetra-grand.webp'
import BronzeFifteen from '../../assets/Partners/Bronze/vaman-plastics.webp'
import BronzeSixteen from '../../assets/Partners/Bronze/VeeNee-powder-coating.webp'
import BronzeSeventeen from '../../assets/Partners/Bronze/bharat-petroleum.webp'
import BronzeEighteen from '../../assets/Partners/WebP-Black/amitronics.webp'
import BronzeNineteen from '../../assets/Partners/WebP-Black/aplica.webp'
import BronzeTwenty from '../../assets/Partners/WebP-Black/cadd-centre.webp'
import BronzeTwentyone from '../../assets/Partners/WebP-Black/Surya-hydraulics.webp'
import BronzeTwentytwo from '../../assets/Partners/WebP-Black/Decofix-Logo.webp'
import BronzeTwentythree from '../../assets/Partners/WebP-Black/henkel-logo.webp'
import BronzeTwentyfour from '../../assets/Partners/WebP-Black/Hitech-Laser-Logo.webp'
import BronzeTwentyfive from '../../assets/Partners/WebP-Black/Jain-spices.webp'
import BronzeTwentysix from '../../assets/Partners/WebP-Black/Lion-circuits.webp'
import BronzeTwentyseven from '../../assets/Partners/WebP-Black/Prakruthi-Packers.webp'
import BronzeTwentyeight from '../../assets/Partners/WebP-Black/PROTECH.webp'
import BronzeTwentynine from '../../assets/Partners/WebP-Black/Rishi-Laser.webp'
import BronzeThirty from '../../assets/Partners/WebP-Black/Sri-Krishna-Weld.webp'
import Narkha from '../../assets/Partners/narkha.png'

//new
import anil from '../../assets/Sponsors24/Anil.png'
import banna from '../../assets/Sponsors24/Banna.png'
import conscientia from '../../assets/Sponsors24/Consceientia.png'
import cubistry from '../../assets/Sponsors24/Cubistry.png'
import dashmesh from '../../assets/Sponsors24/Dashmesh.png'
import dns from '../../assets/Sponsors24/DNS.png'
import gei from '../../assets/Sponsors24/GEI.png'
import hanu from '../../assets/Sponsors24/Hanu.png'
import henkel from '../../assets/Sponsors24/Henkel.png'
import hispeed from '../../assets/Sponsors24/Hi Speed machining.png'
import hitech from '../../assets/Sponsors24/Hi tech laser.png'
import hind from '../../assets/Sponsors24/Hind Forge.png'
import kamal from '../../assets/Sponsors24/Kmal Solar.png'
import krc from '../../assets/Sponsors24/KR Composites.png'
import mnr from '../../assets/Sponsors24/MNR.png'
import motoden from '../../assets/Sponsors24/Motoden.png'
import pooja from '../../assets/Sponsors24/Pooja CNC.png'
import ripple from '../../assets/Sponsors24/Ripple.png'
import silverline from '../../assets/Sponsors24/Silverline.png'
import simscale from '../../assets/Sponsors24/Simscale.png'
import ssk from '../../assets/Sponsors24/SSK.png'
import stratnel from  '../../assets/Sponsors24/Stratnel.png'
import solid from  '../../assets/Sponsors24/SW.png'
import tuner from  '../../assets/Sponsors24/Tuners Craft.png'
import valdel from  '../../assets/Sponsors24/Valdel.png'
import vijay from  '../../assets/Sponsors24/Vijay Infra.png'
import capstone from '../../assets/Sponsors24/capstone.png'
import sriram from '../../assets/Sponsors24/sriram.png'
import yantra from '../../assets/Sponsors24/yantra.jpg'
import accuspirals from '../../assets/Sponsors24/accuspirals.jpg'
import magod from '../../assets/Sponsors24/magod.webp'


export const SponsorItems = [
    {
        id: 'gowri-shankar',
        title: 'Gowrishankar Engineering Industries',
        image: GoldOne,
        level:'Title Sponsor',
        about: 'Gowrishankar Engineering Industries was established in 1985 as a proprietorship Business. Started with a vision to utilize the expertise gained over the years in the automobile industry, the IATF 16949 certified company has for almost three decades served the ever growing automobile sector with quality products.At Gowrishankar Engineering Industries, the customer\'s needs assume the highest degree of importance. The factory organization is thus made extremely flexible to meet the customer\'s requirements in all respects. Our qualified and skilled work force posses extensive expertise in their respective fields and work in an atmosphere of excellent team spirit. Further, the company is equipped with an array of the latest equipment for precision component manufacture, all operating with stringent quality standards. Gowrishankar Engineering Industries is thus well armed and poised, to meet the future challenges of an ever changing and demanding precision component market.',
        web: 'https://gowrishankar.com/',
        webText: 'gowrishankar.com',
        path: "/sponsors/gowri-shankar/",
     

    },
    {
        id:'juno',
        title: 'Juno Equipments',
        image: GoldTwo,
        level:'Title Sponsor',
        about:'',
        path: "/sponsors/juno/",
    },
    {
        id: 'garrett',
        title: 'Garrett Advancing Motion',
        image: SilverOne,
        level: 'Silver',
        about: 'The Garrett name ties back to turbo origins in the 1950s. At that time, entrepreneur and engineer Cliff Garrett led a project team to develop a turbocharger for a Caterpillar D9 crawler tractor, marking the beginning of the turbocharged era for the automotive industry. Garrett technologies and innovations have been used by nearly every major global auto maker, resulting in approximately 100 million vehicles with our products and an average launch rate of 100 new applications annually spanning, gas, diesel, natural gas, electric and fuel cell powertrains. The story of turbo begins in 1954 when Garrett’s T15 turbo was paired with Caterpillar’s D9 crawler. Although the appropriately named Oldsmobile Jetfire Turbo Rocket became the first turbocharged production car in 1962, the technology’s impact was initially felt more keenly in commercial vehicles when in 1967 Deere selected the Garrett T04 turbo for its farm tractor range…and the entire industry followed. But it was in the 1990s that turbo went mainstream and global, when Garrett’s new variable nozzle turbine technology (VNT) enabled the 1991 Fiat Croma to adjust exhaust gas flow in direct response to specific engine requirements. And when Volkswagen-Audi paired VNT technology with its 1.9L diesel engine for its Frankfurt Motor Show launch in 1995, the symbiotic fit between turbocharging and direct injection diesel powertrains was confirmed…and evolution became revolution. Our highly-engineered technologies are rooted in more than 60-years of pioneering turbocharging systems for gasoline and diesel, but today we go further. Our world-class technical solutions are helping to drive a new era in hybrid electrification and fuel-cell powertrains. These innovations enable our customers to set new benchmarks in vehicle performance while addressing evolving fuel efficiency and exhaust emissions regulations. We’re also ready for the connected and autonomous vehicle era, with cybersecurity and prognostic software systems that create a secure and safe operating environment.',
        web: 'https://www.garrettmotion.com/',
        webText: 'www.garrettmotion.com',
        path: '',

    },
    {
        title: '',
        image: SilverTwo,
        path: ''
    },
    {
        title: '',
        image: SilverThree,
        path: ''
    },
    {
        title: '',
        image: BronzeOne,
        path: ''
    },

    {
        title: '',
        image: GoldOne,
        path: ''
    },
    {
        title: '',
        image: BronzeTwo,
        path: ''
    },
    {
        title: '',
        image: BronzeThree,
        path: ''
    },

    {
        title: '',
        image: BronzeFour,
        path: ''
    },
    {
        title: '',
        image: BronzeFive,
        path: ''
    },
    {
        title: '',
        image: BronzeSix,
        path: ''
    },
    {
        title: '',
        image: BronzeSeven,
        path: ''
    },
    {
        title: '',
        image: BronzeEight,
        path: ''
    },

    {
        title: '',
        image: BronzeNine,
        path: ''
    },

    {
        title: '',
        image: BronzeTen,
        path: ''
    },
    {
        title: '',
        image: BronzeEleven,
        path: ''
    },
    {
        title: '',
        image: BronzeTwelve,
        path: ''
    },
    {
        title: '',
        image: BronzeThirteen,
        path: ''
    },
    {
        title: '',
        image: BronzeFourteen,
        path: ''
    },
    {
        title: '',
        image: BronzeFifteen,
        path: ''
    },
    {
        title: '',
        image: BronzeSixteen,
        path: ''
    },
    {
        title: '',
        image: BronzeSeventeen,
        path: ''
    },
    {
        title: '',
        image: BronzeEighteen,
        path: ''
    },
    {
        title: '',
        image: BronzeNineteen,
        path: ''
    },
    {
        title: '',
        image: BronzeTwenty,
        path: ''
    },
    {
        title: '',
        image: BronzeTwentyone,
        path: ''
    },
    {
        title: '',
        image: BronzeTwentytwo,
        path: ''
    },
    {
        title: '',
        image: BronzeTwentythree,
        path: ''
    },
    {
        title: '',
        image: BronzeTwentyfour,
        path: ''
    },
    {
        title: '',
        image: BronzeTwentyfive,
        path: ''
    },
    {
        title: '',
        image: BronzeTwentysix,
        path: ''
    },
    {
        title: '',
        image: BronzeTwentyseven,
        path: ''
    },
    {
        title: '',
        image: BronzeTwentyeight,
        path: ''
    },
    {
        title: '',
        image: BronzeTwentynine,
        path: ''
    },
    {
        title: '',
        image: BronzeThirty,
        path: ''
    },

];


{/*
export const SponsorTitle = [
    {
        title: '',
        image: GoldOne,
        path: ''
    },
    {
        title: '',
        image: GoldTwo,
        path: ''
    },
]

export const SponsorPower= [
    {
        title: 'Garrett Advancing Motion',
        image: SilverOne,
        path: '/sponsors/garrett/'
    },
    {
        title: 'Igus',
        image: SilverTwo,
        path: '/sponsors/igus/'
    },
    {
        title: 'Searock',
        image: SilverThree,
        path: '/sponsors/searock/'
    },
]


export const SponsorAssociation= [
    {
        title: 'Adler',
        image: BronzeOne,
        path: ''
    },
    {
        title: 'Anil Gears',
        image: BronzeTwo,
        path: ''
    },
    {
        title: 'Banna Spray Paints',
        image: BronzeThree,
        path: ''
    },

    {
        title: 'Bharat Rubber',
        image: BronzeFour,
        path: ''
    },
    {
        title: 'Display Mart',
        image: BronzeFive,
        path: ''
    },
    {
        title: 'Eastern Rubber',
        image: BronzeSix,
        path: ''
    },
    {
        title: 'Hanu Heat Treaters',
        image: BronzeSeven,
        path: ''
    },
    {
        title: 'Knorr Bermse',
        image: BronzeEight,
        path: ''
    },

    {
        title: 'Manjunath Metal Finishers',
        image: BronzeNine,
        path: ''
    },

    {
        title: 'Mipox',
        image: BronzeTen,
        path: ''
    },
    {
        title: 'Safemart',
        image: BronzeEleven,
        path: ''
    },
    {
        title: 'Smaaash',
        image: BronzeTwelve,
        path: ''
    },
    {
        title: 'Smart Link',
        image: BronzeThirteen,
        path: ''
    },
    {
        title: 'Tetra Grand',
        image: BronzeFourteen,
        path: ''
    },
    {
        title: 'Vaman Plastics',
        image: BronzeFifteen,
        path: ''
    },
    {
        title: 'Veenee',
        image: BronzeSixteen,
        path: ''
    },
    {
        title: 'Bharat petroleum',
        image: BronzeSeventeen,
        path: ''
    },
    
]
*/}

export const SponsorPower= [
    {
        title: 'Capstone',
        image: capstone,
        path: ''
    },
    {
        title: 'Cubistry',
        image: cubistry,
        path: ''
    },
    {
        title: 'High Speed Machining',
        image: hispeed,
        path: ''
    },
    {
        title: 'Valdel',
        image: valdel,
        path: ''
    },
]

export const SponsorDriven= [
    {
        title: 'Accuspirals',
        image: accuspirals,
        path: ''
    },
    {
        title: 'Pooja Engineering Works',
        image: pooja,
        path: ''
    },
    {
        title: 'Hind Forge',
        image: hind,
        path: ''
    },
    {
        title: 'DNS',
        image: dns,
        path: ''
    },
    {
        title: 'Gowrishankar Engineering Industries',
        image: gei,
        path: ''
    },
    {
        title: 'Magod',
        image: magod,
        path: ''
    },
    {
        title: 'Sri Sairam Power Controls',
        image: sriram,
        path: ''
    },
    {
        title: 'Yantra',
        image: yantra,
        path: ''
    },
]

export const SponsorAssociation= [
    {
        title: 'Anil',
        image: anil,
        path: ''
    },
    {
        title: 'Banna',
        image: banna,
        path: ''
    },
    {
        title: 'Conscientia',
        image: conscientia,
        path: ''
    },
    {
        title: 'Dashmesh Engineering',
        image: dashmesh,
        path: ''
    },
    {
        title: 'Hanu',
        image: hanu,
        path: ''
    },
    {
        title: 'HiTech Laser',
        image: henkel,
        path: ''
    },
    {
        title: 'Hi Tech Laser',
        image: hitech,
        path: ''
    },
    {
        title: 'Kamal Solar',
        image: kamal,
        path: ''
    },
    {
        title: 'K.R.Composites',
        image: krc,
        path: ''
    },
    {
        title: 'MNR',
        image: mnr,
        path: ''
    },
    {
        title: 'Motoden',
        image: motoden,
        path: ''
    },
    {
        title: 'Ripple',
        image: ripple,
        path: ''
    },
    {
        title: 'Silverline Electronics',
        image: silverline,
        path: ''
    },
    {
        title: 'Simscale',
        image: simscale,
        path: ''
    },
    {
        title: 'SSK Traders',
        image: ssk,
        path: ''
    },
    {
        title: 'Stratnel',
        image: stratnel,
        path: ''
    },
    {
        title: 'Solidworks',
        image: solid,
        path: ''
    },
    {
        title: "Tuner's Craft",
        image: tuner,
        path: ''
    },
    {
        title: 'Vijay Infra Projects',
        image: vijay,
        path: ''
    },
]